import Head from 'next/head'
import { useRouter } from 'next/router'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

/** Social scrapers ignore relative URLs, so every shared address is made absolute. */
const absolute = (path: string): string =>
    path.startsWith('http') ? path : `${siteConfig.url}${path}`

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage
}): ReactNode => {
    const router = useRouter()
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const path = (router.asPath.split(/[?#]/)[0] || '/').replace(/\/$/, '')
    const pageUrl = absolute(path || '/')

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={pageUrl} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {ogImage && <meta property='og:image' content={absolute(ogImage)} />}
            {ogImage && <meta name='twitter:image' content={absolute(ogImage)} />}
        </Head>
    )
}
